import axios from 'axios';

const OCR_CONFIG = {
  CLIENT_ID: 'd8oxXWQJj1CLvHUClgeaXc2k',
  CLIENT_SECRET: 'y1Lq6iBfAomYVj4ZW8340O3zoIl4YMVX',
  BASE_URL: 'https://aip.baidubce.com',
  CORS_PROXY: 'https://cors-anywhere.herokuapp.com/'
};

export const ocrService = {
  async getAccessToken() {
    try {
      console.log('Attempting to get access token...');
      const response = await axios({
        method: 'POST',
        url: `${OCR_CONFIG.CORS_PROXY}${OCR_CONFIG.BASE_URL}/oauth/2.0/token`,
        params: {
          grant_type: 'client_credentials',
          client_id: OCR_CONFIG.CLIENT_ID,
          client_secret: OCR_CONFIG.CLIENT_SECRET
        },
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      console.log('Access token response:', response.data);
      return response.data.access_token;
    } catch (error) {
      console.error('Detailed error in getAccessToken:');
      console.error('Error status:', error.response?.status);
      console.error('Error data:', error.response?.data);
      console.error('Request URL:', error.config?.url);
      console.error('Request params:', error.config?.params);
      throw error;
    }
  },

  async processIDCard(imageBase64) {
    try {
      console.log('Starting OCR process...');
      const accessToken = await this.getAccessToken();
      console.log('Got access token:', accessToken);
      
      const requestData = new URLSearchParams({
        image: imageBase64,
        id_card_side: 'front',
        detect_ps: 'false',
        detect_risk: 'false',
        detect_quality: 'false',
        detect_photo: 'false',
        detect_card: 'false',
        detect_direction: 'false'
      }).toString();

      console.log('Making OCR request...');
      const response = await axios({
        method: 'POST',
        url: `${OCR_CONFIG.CORS_PROXY}${OCR_CONFIG.BASE_URL}/rest/2.0/ocr/v1/idcard`,
        params: {
          access_token: accessToken
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        data: requestData
      });

      console.log('OCR response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Detailed error in processIDCard:');
      console.error('Error status:', error.response?.status);
      console.error('Error data:', error.response?.data);
      console.error('Request URL:', error.config?.url);
      console.error('Request params:', error.config?.params);
      console.error('Request headers:', error.config?.headers);
      throw error;
    }
  }
}; 